<template>
  <table class="checkout-table main-cart">
    <tfoot>
      <tr class="checkout-subtotal" v-if="TotalProducts > 0">
        <td class="checkout-subtotal__info" colspan="2">
          <div class="">
            <h4 class="type-h4 add-small-bottom-margin">Subtotal</h4>
            <p class="type-regular">
              Taxes and shipping are calculated at checkout
            </p>
          </div>
        </td>
        <td class="checkout-subtotal__info" colspan="2">
          <div class="checkout-subtotal__amount align-r">
            <span class="type-bold">{{ cartPriceTotal }}</span>
          </div>
        </td>
      </tr>
      <tr v-if="TotalProducts < 1">
        <td class="cart-footer__subtotal--amount" colspan="2">
          <p
            class="align-center type-circular no-bottom-margin type-notransform"
          >
            You currently have no items in your cart.
          </p>
        </td>
      </tr>
    </tfoot>
    <tbody>
      <CartItem
        v-for="item in Items"
        :cartItemData="item"
        :isMiniCart="false"
        :key="item.Id"
        v-if="Items.length > 0"
      ></CartItem>
      <tr v-if="allProductsLoaded < 1 && TotalProducts > 0">
        <td class="width-100">
          <Loading />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import CartItem from "./CartItem.vue";
import axios from "axios";

import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { mapState } from "vuex";

import Loading from "./Loading.vue";

import { FETCH_CART_DATA } from "../vuex/modules/cart/mutations";
import { UPDATE_CART_QUANTITY } from "../vuex/modules/cart/mutations";
import { DELETE_CART_ITEM } from "../vuex/modules/cart/mutations";
// import { RECALCULATE_TOTALS } from '../vuex/modules/cart/mutations';
import { SET_PRODUCT_PRICES } from "../vuex/modules/cart/mutations";

import { FETCH_ITEM_NOTIFICATIONS } from "../vuex/modules/cart/mutations";

export default {
  name: "ShoppingCart",
  components: {
    CartItem,
    Loading,
  },
  data() {
    return {};
  },
  mounted() {
    this.FETCH_ITEM_NOTIFICATIONS();
  },

  methods: {
    ...mapActions({
      // FETCH_CART_DATA,
      // UPDATE_CART_QUANTITY,
      // RECALCULATE_TOTALS,
      FETCH_ITEM_NOTIFICATIONS,
    }),

    handleSubmit() {
      // console.log('submit cart');
    },
  },
  computed: {
    ...mapState({
      Items: (state) => state.cartStore.Items,
      SubTotal: (state) => state.cartStore.SubTotal,
      TotalProducts: (state) => state.cartStore.TotalProducts,
      AllProductIds: (state) => state.cartStore.AllProductIds,
      allProductsLoaded: (state) => state.cartStore.allProductsLoaded,
      Tags: (state) => state.cartStore.Tags,
      Notifications: (state) => state.cartStore.Notifications,
    }),
    ...mapGetters(["totalItemsInCart", "cartPriceTotal", "hasItemsOutOfStock"]),
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ShoppingCart.vue